export default __webpack_public_path__ + "static/media/machdets.11956b8d.jpg";